import {
  BgColorsOutlined,
  CreditCardOutlined,
  LockOutlined,
  LogoutOutlined,
  MailOutlined,
  PieChartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { GlobalToken } from "antd/es/theme/interface";
import { TFunction } from "i18next";
import React from "react";
import { NavLink } from "react-router-dom";

import { useAuthContext } from "../../contexts/auth/useAuthContext";
import { BRANDING, CONTACT, HOME, PROFILE, SUBSCRIPTION } from "../../routes";

interface AppMenuContentProps {
  logo: string;
  token: GlobalToken;
  selectedKeys: string[];
  t: TFunction<"translation", undefined>;
  onLogoutClick: () => void;
  onMenuItemClick?: () => void;
}

const AppMenuContent: React.FC<AppMenuContentProps> = ({
  logo,
  token,
  selectedKeys,
  t,
  onLogoutClick,
  onMenuItemClick,
}) => {
  const { hasSubscription } = useAuthContext();

  const handleMainMenuItemClick = () => {
    if (onMenuItemClick) {
      onMenuItemClick();
    }
  };

  const handleLogoutClick = () => {
    onLogoutClick();
    if (onMenuItemClick) {
      onMenuItemClick();
    }
  };

  return (
    <>
      <div style={{ padding: token.padding, textAlign: "center" }}>
        <img src={logo} alt="Jane" style={{ maxWidth: "100%" }} />
      </div>
      <Menu
        mode="inline"
        style={{ borderRight: 0 }}
        selectedKeys={selectedKeys}
        onClick={handleMainMenuItemClick} // Use the wrapper for main menu items
        items={[
          {
            key: HOME,
            icon: <PieChartOutlined />,
            label: <NavLink to={HOME}>{t("charts")}</NavLink>,
          },
          {
            key: BRANDING,
            icon: <BgColorsOutlined />,
            label: (
              <NavLink
                style={{ display: "flex", justifyContent: "space-between" }}
                to={BRANDING}
                data-tooltip-id={!hasSubscription ? "jane-tooltip" : undefined}
                data-tooltip-content={t(
                  "branding_page.free_plan_subscribe_tooltip"
                )}
                data-tooltip-place="right"
              >
                {t("branding")}
                {!hasSubscription && <LockOutlined />}
              </NavLink>
            ),
          },
          {
            key: PROFILE,
            icon: <UserOutlined />,
            label: <NavLink to={PROFILE}>{t("account")}</NavLink>,
          },
          {
            key: SUBSCRIPTION,
            icon: <CreditCardOutlined />,
            label: <NavLink to={SUBSCRIPTION}>{t("subscription")}</NavLink>,
          },
          {
            key: CONTACT,
            icon: <MailOutlined />,
            label: <NavLink to={CONTACT}>{t("contact_us")}</NavLink>,
          },
        ]}
      />
      <div
        style={{
          position: "absolute",
          bottom: 8,
          width: "100%",
          borderTop: `1px solid ${token.colorBorderSecondary}`,
        }}
      >
        <Menu
          mode="inline"
          style={{ borderRight: 0 }}
          items={[
            {
              key: "logout",
              icon: <LogoutOutlined />,
              onClick: handleLogoutClick,
              label: t("logout"),
            },
          ]}
        />
      </div>
    </>
  );
};

export default AppMenuContent;
